module.exports = __webpack_public_path__ + "img/info.d0338d32.svg";